import { useQuery } from '@apollo/client';
import React from 'react';
import DiaryEventWorkspaceQuery from '../../graphql/queries/diary/DiaryEventWorkspaceQuery.graphql';
import OverviewEventField from '../../components/connectedForm/OverviewEventField';
import {
  Direction,
  IEvent,
  IEventsQueryResult,
  IEventsQueryVariables,
  IFilterInput,
} from '../../graphql/schema/p4types';

export const useEventDetails = (filters: Array<IFilterInput>, skip?: boolean) => {
  const eventVariables: IEventsQueryVariables = {
    first: 5,
    after: '0',
    orderBy: 'eventStart',
    orderDirection: Direction.Desc,
    filters,
  };
  const { data: eventsData } = useQuery<IEventsQueryResult, IEventsQueryVariables>(DiaryEventWorkspaceQuery, {
    variables: eventVariables,
    fetchPolicy: 'network-only',
    skip,
  });

  if (eventsData?.listData && Array.isArray(eventsData.listData.edges)) {
    let idx = 0;
    const count = eventsData.listData.edges.length > 3 ? 4 : eventsData.listData.edges.length;
    return {
      totalCount: eventsData.listData.count,
      count: count,
      list: eventsData.listData.edges.map((ev) => {
        if (++idx < 5) {
          return <OverviewEventField key={`_${idx}`} last={idx === count} {...(ev!.node as IEvent)} />;
        }
      }),
    };
  }
  return {
    totalCount: 0,
    count: 0,
    list: [],
  };
};
